import React from 'react';
import Navbar from '../components/Navbar';
import { ClockCounterClockwise, Sparkle, Bug, Wrench, Rocket } from '@phosphor-icons/react';

const releases = [
  {
    version: 'v1.4.0',
    date: 'April 2026',
    tag: 'Terbaru',
    tagColor: 'bg-primary text-white',
    icon: Rocket,
    changes: [
      { type: '✨', text: 'QR Code Overlay: tampilkan QR code custom dengan logo di tengah untuk scan langsung dari stream' },
      { type: '✨', text: 'Text-to-Speech (TTS): pesan donasi dibacakan otomatis (Indonesia, Inggris, Jepang)' },
      { type: '✨', text: 'Kustomisasi QR: ganti label teks, warna aksen, dan preview langsung di dashboard' },
      { type: '🔧', text: 'Perbaikan transparansi overlay di OBS: semua widget sekarang 100% transparan' },
      { type: '🔧', text: 'Tombol bantuan otomatis disembunyikan di halaman overlay' },
      { type: '📄', text: 'Halaman Syarat & Ketentuan, Kebijakan Privasi, dan Changelog' },
      { type: '📄', text: 'FAQ dan Panduan Pengguna diperbarui dengan fitur TTS & QR' },
    ]
  },
  {
    version: 'v1.3.0',
    date: 'April 2026',
    tag: 'Stable',
    tagColor: 'bg-secondary',
    icon: Sparkle,
    changes: [
      { type: '✨', text: 'Overlay Live Streaming: Alert Box, Leaderboard, Running Text, Subathon Timer' },
      { type: '✨', text: 'Media Share: donatur bisa kirim link YouTube untuk diputar di layar streamer' },
      { type: '✨', text: 'Voting interaktif: polling real-time lewat pesan donasi (#1, #2, dst)' },
      { type: '✨', text: 'Donation Goal overlay widget untuk OBS/Streamlabs' },
      { type: '✨', text: 'Dashboard Overlay Settings: konfigurasi token, animasi, warna, dan URL widget' },
      { type: '🛡️', text: 'Sensor kata kasar terintegrasi di semua overlay streaming' },
      { type: '🔧', text: 'SSE (Server-Sent Events) untuk push notifikasi real-time ke overlay' },
    ]
  },
  {
    version: 'v1.2.0',
    date: 'April 2026',
    tag: 'Stable',
    tagColor: 'bg-secondary',
    icon: Sparkle,
    changes: [
      { type: '✨', text: 'Login & Register dengan Google (OAuth)' },
      { type: '✨', text: 'Halaman Forgot Password & Reset Password' },
      { type: '✨', text: 'Halaman FAQ dan Panduan Pengguna' },
      { type: '🔧', text: 'Perbaikan fee platform dari flat ke persentase (3%)' },
      { type: '🐛', text: 'Fix webhook mismatch dengan Pakasir payment gateway' },
    ]
  },
  {
    version: 'v1.1.0',
    date: 'April 2026',
    tag: 'Feature',
    tagColor: 'bg-accent',
    icon: Wrench,
    changes: [
      { type: '✨', text: 'Dashboard Analytics: grafik pendapatan harian & bulanan' },
      { type: '✨', text: 'Goals (Target Pendanaan) dengan progress bar real-time' },
      { type: '✨', text: 'Penarikan dana ke rekening bank lokal' },
      { type: '✨', text: 'Admin panel untuk monitoring platform' },
      { type: '🔧', text: 'Notifikasi email saat ada traktiran baru' },
    ]
  },
  {
    version: 'v1.0.0',
    date: 'Maret 2026',
    tag: 'Initial',
    tagColor: 'bg-foreground text-background',
    icon: Rocket,
    changes: [
      { type: '🚀', text: 'Rilis awal platform Traktirkan' },
      { type: '✨', text: 'Halaman profil kreator publik (traktirkan.com/u/username)' },
      { type: '✨', text: 'Checkout QRIS via Pakasir payment gateway' },
      { type: '✨', text: 'Supporter feed real-time di halaman kreator' },
      { type: '✨', text: 'Moderasi kata kasar otomatis pada pesan donasi' },
      { type: '✨', text: 'Dashboard kreator dengan manajemen unit traktiran' },
    ]
  },
];

export default function Changelog() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 border-2 border-foreground bg-accent shadow-brutal mb-4 rotate-3">
            <ClockCounterClockwise size={32} weight="bold" />
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-bold tracking-tight">CHANGE<span className="text-primary italic">LOG</span></h1>
          <p className="text-foreground/60 mt-2 uppercase tracking-widest text-xs font-bold">Riwayat Perubahan & Pembaruan</p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-foreground/15 hidden md:block" />

          <div className="space-y-8">
            {releases.map((r, i) => (
              <div key={i} className="relative md:pl-16">
                {/* Timeline dot */}
                <div className="hidden md:flex absolute left-4 top-6 w-5 h-5 border-2 border-foreground bg-white items-center justify-center z-10">
                  <div className="w-2 h-2 bg-primary" />
                </div>

                <div className="border-2 border-foreground bg-white shadow-brutal-md overflow-hidden">
                  <div className="flex items-center gap-3 p-5 border-b-2 border-foreground/10 bg-background/50">
                    <r.icon size={24} weight="bold" className="text-primary" />
                    <h2 className="font-display text-2xl font-bold">{r.version}</h2>
                    <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 border-2 border-foreground ${r.tagColor}`}>{r.tag}</span>
                    <span className="text-xs text-muted-foreground font-bold ml-auto">{r.date}</span>
                  </div>
                  <ul className="p-5 space-y-2">
                    {r.changes.map((c, j) => (
                      <li key={j} className="flex items-start gap-3 text-sm">
                        <span className="text-base shrink-0">{c.type}</span>
                        <span className="text-foreground/80">{c.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
